(function () {
  function boot() {
    document.querySelectorAll('[data-featured-glas]').forEach((root) => {
      if (root.__featuredInit) return;
      root.__featuredInit = true;

      const jsonEl = root.querySelector('[data-featured-glas-json]');
      const imgEl = root.querySelector('[data-featured-glas-img]');
      if (!jsonEl || !imgEl) return;

      let payload;
      try { payload = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      const map = (payload && payload.featured) ? payload.featured : {};

      function getVariantId() {
        const input = document.querySelector('input[name="id"]');
        return input && input.value ? String(input.value) : null;
      }

      function update() {
        const vid = getVariantId();
        if (!vid) return;

        const url = map[String(vid)] || "";
        if (!url) {
          imgEl.style.display = "none";
          imgEl.removeAttribute("src");
          return;
        }

        // nur setzen, wenn sich die URL ändert (verhindert Flackern)
        if (imgEl.getAttribute("src") !== url) imgEl.setAttribute("src", url);
        imgEl.style.display = "block";
      }

      update();

      document.addEventListener("variant:change", update);
      document.addEventListener("variant:changed", update);

      const idInput = document.querySelector('input[name="id"]');
      if (idInput) idInput.addEventListener("change", update);

      setTimeout(update, 400);
      setTimeout(update, 900);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();